import React, { useState } from "react";
import FormInput from "../FormInputs/FormInput";
import "../SignupForm/signupForm.scss";
import "./reservationForm.scss";
import { Formik } from "formik";

//React DatePicker Calendar
import DatePicker from "react-datepicker";
import "./react-datepicker.css";
import FormCard from "components/Cards/FormCard/FormCard";
import axios from "axios";
import { useHistory } from "react-router-dom";

import warning from "assets/icons/warning.png";

const validation = (values) => {
  let errors = {};

  if (!values.start_date) {
    errors.start_date = "Debe seleccionar una fecha de check-in";
  }
  if (!values.end_date) {
    errors.end_date = "Debe seleccionar una fecha de check-out";
  }
  if (values.start_time === "placeholder") {
    errors.start_time = "Debe seleccionar un horario de retiro";
  }

  return errors;
};

const ReservationForm = ({ user, product, occupation }) => {
  const history = useHistory();
  const [errorState, setErrorState] = useState(false);

  const reservation = async (
    start_date,
    end_date,
    start_time,
    product_id,
    user_id
  ) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/reservations`,
        {
          start_date,
          end_date,
          start_time,
          product_id,
          user_id,
        },
        { headers: { Authorization: `Bearer ${user.jwt}` } }
      );
      history.push("/reservation/success");
    } catch (error) {
      setErrorState(true);
      console.log(error.message);
    }
  };

  return (
    <Formik
      initialValues={{
        name: user.name,
        surname: user.surname,
        email: user.email,
        city: user.city,
        start_date: new Date(),
        end_date: null,
        start_time: "placeholder",
      }}
      onSubmit={async (values, actions) => {
        await reservation(
          values.start_date.toISOString().slice(0, 10),
          values.end_date.toISOString().slice(0, 10),
          values.start_time,
          product.id,
          user.id
        );
        actions.setSubmitting(false);
      }}
      validate={validation}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {/**This props are injected by Formik*/}
      {(props) => (
        <ReservationFormTemplate
          {...props}
          product={product}
          occupation={occupation}
          errorState={errorState}
        />
      )}
    </Formik>
  );
};

const getTimeOptions = () => {
  const timeOptions = [];
  for (let i = 1; i < 25; i++) {
    let timeOption = {};
    if (i < 13) {
      timeOption = {
        label: `${i} AM`,
        value: `${String(i).padStart(2, "0")}:00:00`,
      };
    } else if (i < 24) {
      timeOption = {
        label: `${i - 12} PM`,
        value: `${String(i).padStart(2, "0")}:00:00`,
      };
    } else {
      timeOption = {
        label: `${i - 12} PM`,
        value: `${String(i - 24).padStart(2, "0")}:00:00`,
      };
    }
    timeOptions.push(timeOption);
  }
  return timeOptions;
};

const ReservationFormTemplate = ({
  handleSubmit,
  product,
  occupation,
  handleChange,
  values,
  isValid,
  setFieldValue,
  dirty,
  errorState,
}) => {
  //DatePicker States
  const [validDate, setValidDate] = React.useState(true);
  const [calendarError, setCalendarError] = React.useState(false);

  const onChange = (dates) => {
    const [start, end] = dates;
    setFieldValue("start_date", start);
    setFieldValue("end_date", end);
    const currentOccupation = occupation.filter(
      (reservation) => reservation.end > new Date()
    );
    if (currentOccupation.length > 0) {
      setValidDate(true);
      setCalendarError(false);
      for (let index = 0; index < currentOccupation.length; index++) {
        const reservation = currentOccupation[index];
        if (start < reservation.start && end > reservation.end) {
          setCalendarError(true);
          setValidDate(false);
          break;
        }
      }
    }
  };

  // Rezise Functions for the Carousel and the calendar
  const [size, setSize] = React.useState(window.innerWidth);

  React.useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <form className="reservationForm" onSubmit={handleSubmit}>
      <div className="reservationForm__dataInput">
        <div className="reservationForm__dataInput__userInfo">
          <h2>Completá tus datos</h2>
          <div className="reservationForm__dataInput__userInfo__container">
            <FormInput disabled name="name" type="text" label="Nombre" />
            <FormInput disabled name="surname" type="text" label="Apellido" />
            <FormInput
              disabled
              name="email"
              type="text"
              inputMode="email"
              label="Correo"
            />
            <FormInput disabled name="city" type="text" label="Ciudad" />
          </div>
        </div>

        <div className="reservationForm__dataInput__calendar">
          <h2>Selecciona tu fecha de reserva</h2>
          <div className="reservationForm__dataInput__calendar__wrapper">
            <DatePicker
              onChange={onChange}
              startDate={values.start_date}
              endDate={values.end_date}
              excludeDateIntervals={occupation}
              selectsRange
              monthsShown={size <= 745 ? 1 : 2}
              inline
              minDate={new Date()}
            />
          </div>
          <div
            className={calendarError ? "calendar-error" : "calendar-success"}
          >
            No puedes reservar durante fechas deshabilitadas, por favor
            selecciona otro rango de fechas.
          </div>
        </div>

        <div className="reservationForm__dataInput__timePicker">
          <h2>Tu horario de retiro</h2>
          <div className="reservationForm__dataInput__timePicker__container">
            <p>Indica el horario en el que retirarás el vehículo</p>
            <select
              onChange={handleChange}
              value={values.start_time}
              name="start_time"
              id="start_time"
            >
              <option value="placeholder">Seleccionar hora de retiro</option>
              {getTimeOptions().map((timeOption) => (
                <option value={timeOption.value} key={timeOption.value}>
                  {timeOption.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="reservationForm__card">
        {errorState && (
          <div className="errorLoginReserve">
            <img src={warning} alt="warning" />
            <p>
              Lamentablemente la reserva no ha podido realizarse. Por favor,
              intente más tarde
            </p>
          </div>
        )}
        <h2>Detalle de la reserva</h2>
        <FormCard
          disabled={!isValid || !dirty || !validDate}
          product={product}
          dates={{
            check_in: values.start_date
              ? values.start_date
                  .toISOString()
                  .slice(0, 10)
                  .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1")
              : "",
            check_out: values.end_date
              ? values.end_date
                  .toISOString()
                  .slice(0, 10)
                  .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1")
              : "",
            withdrawal_time:
              values.start_time !== "placeholder"
                ? values.start_time.slice(0, 5)
                : null,
          }}
        />
      </div>
    </form>
  );
};

export default ReservationForm;
